
define('modules/application/wizard/classes/exportProjectConfiguration',[
    "app",

    // Libs
    "backbone",

    //Classes
    "./exportElement"

  ],

  function(app, Backbone, exportElement) {

    var exportProjectConfiguration = _.extend({}, exportElement, {

      Views: {
        titleBar: exportElement.Views.titleBar.extend({
          afterRender: function() {
            this.$el.children(".titleBarcontent").prepend($.i18n._("IDS_W1_9025"));
          }
        }),
        content: exportElement.Views.content.extend({

          events: {
            "click .project-pdf"         : "requestExport",
            "click #clipboardJSonSend"   : "clipboardJSonSendEventHandler",
            "click #clipboardJSonReceive": "clipboardJSonReceiveEventHandler"
          },

          initialize: function() {
            this.loader = new window.BticinoS4B.Instances.Views.LoaderView({
              model: {
                quote: "IDS_W1_9025",
                closeButton: true
              }
            });
            this.model.get("eventAggregator").bind("loader:hide", this.hideLoader, this);
            this.model.get("eventAggregator").bind("loader:download", this.addDownloadView, this);
            this.insertView(".popups", this.loader);
          },

          requestExport: function() {
            this.loader.render();
            this.loader.show(this.triggerRequestExport, undefined, this);
          },

          triggerRequestExport: function() {
            window.BticinoS4B.eventAggregator.trigger("export:requested");
          },

          showDebugPrompt: function(text){
            window.prompt("Copy to clipboard: Ctrl+C, Enter", text);
          },

          clipboardJSonSendEventHandler: function(){
            var text = JSON.stringify(BticinoS4B.Instances.Models.ApplicationModel.get("lastReportConfigurationSend"));
            var res = BticinoS4B.jsbeautifier.js_beautify(text);
            this.showDebugPrompt(res);
          },

          clipboardJSonReceiveEventHandler: function(){
            var text = JSON.stringify(BticinoS4B.Instances.Models.ApplicationModel.get("lastReportConfigurationResponse"));
            var res = BticinoS4B.jsbeautifier.js_beautify(text);
            this.showDebugPrompt(res);
          },

          hideLoader: function() {
            this.loader.hide();
          },

          addDownloadView: function() {
            var loaderView = this.loader;
            var title = loaderView.$el.find(".header p");
            var that = this;

            loaderView.$el.find(".content").fadeOut("100", function() {
              var content = loaderView.$el.find(".content");
              content.html("");
              content.append("<a data-bypass target=\"_blank\" href=\"" + that.model.get("pdfUrl") + "\" class=\"download-button\"><button class=\"orange-button\">Download</button></a>");
              content.fadeIn("100");
              content.find(".download-button").bind("click", function(e) {
                e.preventDefault();
                loaderView.hide();
                window.open(that.model.get("pdfUrl"));
              });
            });

            title.fadeOut("100", function() {
              title.text($.i18n._("IDS_W1_9096"));
              title.fadeIn("100", function() {
                $.colorbox.resize();
              });
            });
          },

          afterRender: function() {
            this.$el.children("a").prepend($.i18n._("IDS_W1_9025"));
            this.$el.children(".first").children(".button-list").append("<li><button class='project-pdf'><img src='/assets/img/adobe-logo.png' /><p class='text'>" + $.i18n._("IDS_W1_9025") + "</p></button></li>");

            if (BticinoS4B.devMode.enabled){
              this.$el.children(".first").children(".button-list").append('<li><button id="clipboardJSonSend">JSon Send</button></li>');
              this.$el.children(".first").children(".button-list").append('<li><button id="clipboardJSonReceive">JSon Receive</button></li>');
            }

          }

        })
      },

      Model: exportElement.Model.extend({
        defaults: {
          eventAggregator: _.extend({}, Backbone.Events),
          quoteIds: "IDS_WGENTT_000049"
        },

        initialize: function() {
          window.BticinoS4B.eventAggregator.bind("export:requested", this.generateReport, this);
        },

        compileConfigurationItem: function(item) {
          var i = 0;
          var itemToReturn = {};
          var getZoneName = BticinoS4B.Instances.Models.ApplicationModel.get("getZoneName");
          if (item.conf) {
            slot = [];

            if (item.slot)
              for (i = 0; i < item.slot.length; i++) {
                if (item.slot[i].Z)
                  slotToAdd = {
                    idLink: item.slot[i].idLink,
                    DescriSlotNumber: "Slot " + (i + 1),
                    Descri: getZoneName(item.slot[i].Z) + " - " + "N" + item.slot[i].N + " - Nr. " + item.slot[i].progNumber + " - " + $.i18n._(item.slot[i].packageClassLabel)
                  };
                else
                  slotToAdd = {
                    idLink: item.slot[i].idLink,
                    DescriSlotNumber: item.slot[i].DescriSlotNumber,
                    Descri: item.slot[i].Descri
                  };
                slot.push(slotToAdd);
              }

            var firstSpaceOccurrence = -1;
            for (i = 0;
              (i < item.conf.length); i++)
              if (item.conf[i].confName) {
                firstSpaceOccurrence = item.conf[i].confName.indexOf(" ");
                if (firstSpaceOccurrence > 0)
                  item.conf[i].confName = item.conf[i].confName.substring(0, firstSpaceOccurrence);
              }

            if (!item.productCode)
              BticinoS4B.Instances.Models.ApplicationModel.getProducts(item.packageClassId, function(data) {
                var product = _.filter(data.products, function(product) {
                  return product.mnemonic === 1;
                })[0];
                _.extend(item, product);
              });

            itemToReturn = {
              progNumber: item.progNumber,
              wizardPackName: $.i18n._(item.packageClassLabel),
              itemcode: item.productCode,
              packageClassId: item.packageClassId,
              conf: item.conf,
              slot: slot
            };

            return itemToReturn;
          } else
            return null;
        },

        generateReport: function() {
          var that = this;
          window.BticinoS4B.eventAggregator.trigger("modelDeliver:request", this);
          BticinoS4B.Instances.Models.ApplicationModel.startAutomaticCalculation();

          var dataToSend = {},
            slotToAdd = {},
            itemToAdd = {};
          var slot = [];
          var k = 0,
            i = 0,
            j = 0,
            l = 0;
          var getZoneName = BticinoS4B.Instances.Models.ApplicationModel.get("getZoneName");

          //Initial datas
          dataToSend.token = window.BticinoS4B.token;
          dataToSend.configuration = {
            fileoutformat: "PDF",
            //filerepx      : "BTReportThermoConfig002"
            filerepx: "S4BReportConfig"
          };

          //Generic
          dataToSend.generic = {
            legami: $.i18n._("IDS_W1_9099"),
            Note1:  $.i18n._("IDS_W1_9118"),
            Note2:  $.i18n._("IDS_W1_9119")
          };

          //Header
          dataToSend.header = {
            logo           : "",
            quote_n        : BticinoS4B.Instances.Models.ApplicationModel.get("projectId") ? BticinoS4B.Instances.Models.ApplicationModel.get("projectId") : 0,
            quote_date     : BticinoS4B.Instances.Models.ApplicationModel.get("projectModified") ? moment(BticinoS4B.Instances.Models.ApplicationModel.get("projectModified")).format('L') : moment().format('L'),
            quote_pricelist: $.i18n._("IDS_W1_9076"),
            quote_operator : BticinoS4B.Instances.Models.loginModel.get("username"),
            quote_name     : BticinoS4B.Instances.Models.ApplicationModel.get("projectName") ? BticinoS4B.Instances.Models.ApplicationModel.get("projectName") : "quote",
            quote_note     : BticinoS4B.Instances.Models.ApplicationModel.get("projectNote")   ? BticinoS4B.Instances.Models.ApplicationModel.get("projectNote")   : "",
            quote_ticket   : BticinoS4B.Instances.Models.ApplicationModel.get("projectTicket") ? BticinoS4B.Instances.Models.ApplicationModel.get("projectTicket") : ""
          };

          //Footer
          dataToSend.footer = {};

          //Items
          dataToSend.items = [];
          var actuators = BticinoS4B.Instances.Models.ApplicationModel.get("completeConfiguration").get("actuators"),
            actuatorsLength = actuators ? actuators.length : 0;
          var outOfZoneArticles = BticinoS4B.Instances.Models.ApplicationModel.get("completeConfiguration").get("outOfZoneArticles"),
            outOfZoneArticlesLength = outOfZoneArticles ? outOfZoneArticles.length : 0;
          var zoneArticles = BticinoS4B.Instances.Models.ApplicationModel.get("completeConfiguration").get("zoneArticles"),
            zoneArticlesLength = zoneArticles ? zoneArticles.length : 0;

          for (i = 0; i < actuatorsLength; i++) {
            itemToAdd = this.compileConfigurationItem(actuators[i]);
            if (itemToAdd) {
              itemToAdd.level_1 = $.i18n._("IDS_W1_9097");
              dataToSend.items.push(itemToAdd);
            }
          }

          for (i = 0; i < outOfZoneArticlesLength; i++) {
            itemToAdd = this.compileConfigurationItem(outOfZoneArticles[i]);
            if (itemToAdd) {
              itemToAdd.level_1 = $.i18n._("IDS_W1_9098");
              dataToSend.items.push(itemToAdd);
            }
          }

          for (i = 0; i < zoneArticlesLength; i++) {
            for (j = 0; j < zoneArticles[i].items.length; j++) {
              itemToAdd = this.compileConfigurationItem(zoneArticles[i].items[j]);

              if (itemToAdd) {
                itemToAdd.level_1 = getZoneName(zoneArticles[i].number);
                dataToSend.items.push(itemToAdd);
              }
            }
          }
          BticinoS4B.Instances.Models.ApplicationModel.set('lastReportConfigurationSend', dataToSend);
          $.ajax({
            type: "POST",
            datatype: "json",
            contentType: "application/json",
            url: "/btreport/JSonInterface.asmx/JSonMakeReportThermoConfig",
            data: JSON.stringify(dataToSend),
            success: function(data) {
              BticinoS4B.Instances.Models.ApplicationModel.set('lastReportConfigurationResponse', data);
              var pdfUrl = data.d.fileUrl;
              that.set("pdfUrl", pdfUrl);
              that.get("eventAggregator").trigger("loader:download");
            },
            error: function(e) {
              that.get("eventAggregator").trigger("loader:hide");
            }
          });
        }
      })
    });

    // Required, return the module for AMD compliance
    return exportProjectConfiguration;

  });